import Moment from 'moment'
import moment from "moment";
import MenuGroupItem from "@/model/menu/MenuGroupItem";
import i18n from "@/i18n";

export default class DailyMenuOfferOrder {

  private constructor (
    readonly date: Date,
    readonly menuGroupList: MenuGroupItem[],

  ) {}

  get dayName (): string {
    const date = Moment(this.date);
    date.locale(i18n.locale)
    return date.format("dddd")
  }

  get formatedDbDate (): string {
    const date = moment(this.date)
    return date.format('Y-MM-DD')
  }

  get displayDate (): string {
    return moment(this.date).format('D.M.Y')
  }

  get formatedDate (): string {
    const date = Moment(this.date);
    return date.format("D.M.Y")
  }

  static createFromResponse (responseData: any): DailyMenuOfferOrder {
    return new DailyMenuOfferOrder(
      Moment(responseData.date).toDate(),
      MenuGroupItem.createFromList(responseData.data)
    )
  }
}
